/* Shared color palette for Iraqi case categories.
   Source of truth for both the Cassation Library (المحكمة التمييزية)
   and the lawyer's own cases list — so a "مدنية" badge looks the same
   wherever it appears in the app. */

export const CASE_TYPES = [
  "مدنية", "تجارية", "جزائية", "جنايات", "شخصية", "عمالية", "إدارية",
];

export const TYPE_COLOR = {
  مدنية: "#0A192F",   // navy
  تجارية: "#5C6BC0",  // indigo
  جزائية: "#8B0000",  // deep maroon
  جنايات: "#B91C1C",  // vivid red (criminal felonies)
  شخصية: "#2E8B57",   // sea green (الأحوال الشخصية)
  عمالية: "#D4AF37",  // gold (عمل / علاقة عمل)
  إدارية: "#8A6BBE",  // purple
};

/* The AI's free-form case_type strings sometimes use the short form
   ("عمل" instead of "عمالية") or include قيود/توضيحات. Map those to
   the canonical category so the color lookup is consistent. */
const ALIASES = {
  عمل: "عمالية",
  عمالي: "عمالية",
  "أحوال شخصية": "شخصية",
  "الأحوال الشخصية": "شخصية",
  جنائية: "جنايات",
};

/* Strip parens/dashes and normalize whitespace so
   "عمل (علاقة عمل تعاقدية - فصل/ترك عمل)" → "عمل". */
export const shortCaseType = (s) => {
  if (!s) return "";
  return s.split(/[(\-،,]/)[0].trim();
};

export const canonicalCaseType = (raw) => {
  const short = shortCaseType(raw);
  return ALIASES[short] || short;
};

export const caseTypeColor = (raw, fallback = "#0A192F") => {
  return TYPE_COLOR[canonicalCaseType(raw)] || fallback;
};
